<script setup lang="ts">
import useCpBem from '~/composables/useCpBem';
import {useCategoriesMenu} from '~/composables/useCategoriesMenu';
import {useCategoriesMenuStore} from '~/stores';
import {getFlatCategories, useCategoryTree} from '~/composables';
import {useCatalogStore} from '~/stores/catalogStore';

const CATEGORIES_PATH = '/Categorias';
const DEFAULT_CNID = '99748977a0a9f40e2.09126772';

const route = useRoute();
const {b} = useCpBem('cp-categories');
const {selectCategory} = useCategoriesMenu();
const categoriesStore = useCategoriesMenuStore();

const {data: catTree} = await useCategoryTree();
categoriesStore.setCategories(catTree.value);
categoriesStore.setFlatCategories(getFlatCategories(catTree.value ?? []));

const nuxtApp = useNuxtApp();

const getSeoData = async () => {
  if (route.path === CATEGORIES_PATH) {
    return {
      isParent: false,
      cnid: DEFAULT_CNID,
    };
  }

  const {data: parse} = await useParseSeoUrl(route.fullPath, route.path, nuxtApp.ssrContext?.event);
  const isParent = flatCategories[parse.value.cnid]?.subCategories?.length;

  return {
    isParent,
    cnid: parse.value.cnid,
  };
};

const {isParent, cnid} = await getSeoData();
if (isParent) {
  selectCategory(cnid);
  const catalogStore = useCatalogStore();
  await catalogStore.init();
  useSeoMeta(catalogStore.seoMeta);
  useHead(catalogStore.getHead);
} else {
  selectCategory(DEFAULT_CNID);
  useSeoMeta({
    title: 'Cyberpuerta.mx: Hardware, Computadoras, Laptops & Más',
    description: 'content="Venta en línea de Hardware, Computadoras, Laptops, Impresoras, Monitores y más.\n' +
      '✓Precios accesibles ✓Excelente servicio \n' +
      '✓55,000 productos ✓15 años en el mercado ✓500,000+ clientes"\n',
    ogUrl: 'https://www.cyberpuerta.mx',
    ogTitle: 'Cyberpuerta.mx: Hardware, Computadoras, Laptops & Más',
    ogDescription: 'Venta en línea de Hardware, Computadoras, Laptops, Impresoras, Monitores y más.\n' +
      '&#10003;Precios accesibles &#10003;Excelente servicio \n' +
      '&#10003;55,000 productos &#10003;15 años en el mercado &#10003;500,000+ clientes',
    ogImage: 'https://www.cyberpuerta.mx/out/cyberpuertaV5/img/logo2.png',
    ogImageWidth: '381',
    ogImageHeight: '82',
  });
}

</script>

<template>
    <div :class="b">
        <CpMainNavMenu />
    </div>
</template>

<style scoped lang="scss">
.cp-categories {
  flex: 1;
  display: flex;
  height: 100%;
  overflow: hidden;
}
</style>
